import React from 'react';
import PropTypes from 'prop-types';
import { READ_ONLY_LABEL } from '../../utils/constants';

export default function DashboardHeader(props) {
  const { result, isReadOnly } = props;
  return (
    <div className="col-container shipment-view">
      <div className="rowterms">
        <div className="columnterms">
          <div className="blue-column">GB ENS</div>
        </div>
        <div className="columnterms">
          <div className="green-column">Shipping View{isReadOnly ? READ_ONLY_LABEL : ''}</div>
        </div>
        <div className="columnterms">
          <div className="green-column"></div>
        </div>
      </div>
    </div>
  );
}
DashboardHeader.propTypes = {
  result: PropTypes.string,
};
